<template>
  <div class="login-container">
    <!-- Hiasan Garis Aksen Diagonal -->
    <div class="brand-stripe-top"></div>

    <div class="login-card">
      <!-- Header Branding / Logo Gembok 4 Warna -->
      <div class="brand-header">
        <div class="brand-logo">
          <!-- Logo Gembok dengan kombinasi 4 warna branding -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="56" height="56">
            <!-- Gagang Atas Kiri (Oranye) -->
            <path d="M 32,50 V 32 A 18,18 0 0 1 50,14" stroke="#FF9A00" stroke-width="10" stroke-linecap="round" fill="none" />
            <!-- Gagang Atas Kanan (Biru Muda) -->
            <path d="M 50,14 A 18,18 0 0 1 68,32 V 50" stroke="#1B4D9B" stroke-width="10" stroke-linecap="round" fill="none" />
            <!-- Badan Gembok Utama (Biru Utama) -->
            <rect x="22" y="44" width="56" height="42" rx="8" fill="#0B3C85" />
            <!-- Lubang Kunci & Akses Dalam (Merah) -->
            <circle cx="50" cy="60" r="6" fill="#FF3D00" />
            <polygon points="46,62 54,62 52,76 48,76" fill="#FF3D00" />
          </svg>
        </div>
        <h2 class="company-title">JIKUOPS</h2>
        <p class="company-subtitle">Portal Masuk Sistem</p>
      </div>

      <!-- Form Login -->
      <form @submit.prevent="onLogin" class="login-form">
        
        <!-- Input Username dengan Floating Label -->
        <div class="form-group floating-group">
          <div class="input-wrapper">
            <span class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E53935" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </span>
            <input 
              type="text" 
              id="username" 
              v-model.trim="username" 
              placeholder=" " 
              autocomplete="username"
              required
              :disabled="loading"
            />
            <label for="username" class="floating-label">Username</label>
          </div>
        </div>

        <!-- Input Password dengan Floating Label -->
        <div class="form-group floating-group">
          <div class="input-wrapper">
            <span class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E53935" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </span>
            <input 
              :type="showPassword ? 'text' : 'password'" 
              id="password" 
              v-model="password" 
              placeholder=" " 
              autocomplete="current-password"
              required
              :disabled="loading"
            />
            <label for="password" class="floating-label">Password</label>
            
            <!-- Tombol Toggle Password -->
            <button 
              type="button" 
              class="toggle-password" 
              @click="showPassword = !showPassword"
              tabindex="-1"
              :aria-label="showPassword ? 'Sembunyikan password' : 'Tampilkan password'"
            >
              <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
        </div>

        <!-- Tombol Masuk -->
        <button type="submit" class="btn-login" :disabled="loading">
          <span v-if="loading" class="spinner"></span>
          <span>{{ loading ? 'Memproses...' : 'MASUK' }}</span>
        </button>
      </form>

      <!-- Footer -->
      <div class="card-footer">
        <p>PT Jaringan Inklusi Keuangan &copy; {{ new Date().getFullYear() }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      showPassword: false
    }
  },
  methods: {
    async onLogin() {
      if (!this.username || !this.password) {
        Swal.fire({
          icon: 'warning',
          title: 'Peringatan',
          text: 'Username dan Password harus diisi',
          confirmColor: '#0B3C85'
        })
        return
      }

      this.loading = true

      try {
        const response = await fetch(`${this.$apiURL}/v1/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            username: this.username,
            password: this.password
          })
        })

        const result = await response.json()

        if (result.success) {
          localStorage.setItem('token', result.access_token)
          localStorage.setItem('expires_at', result.expires_at)
          localStorage.setItem('user', JSON.stringify(result.data))

          const bankNama = result.data?.bank?.nama ? ` (${result.data.bank.nama})` : ''

          Swal.fire({
            icon: 'success',
            title: 'Berhasil Login',
            text: `Selamat datang kembali${bankNama}!`,
            timer: 1500,
            showConfirmButton: false
          }).then(() => {
            this.$router.push('/dashboard')
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Gagal Login',
            text: result.message || 'Username atau password salah',
            confirmColor: '#0B3C85'
          })
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error Koneksi',
          text: 'Terjadi kesalahan saat terhubung ke server',
          confirmColor: '#0B3C85'
        })
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    const token = localStorage.getItem('token')
    const expiresAt = localStorage.getItem('expires_at')

    if (token && expiresAt) {
      const now = new Date().getTime()
      const expiredTime = new Date(expiresAt).getTime()

      if (now >= expiredTime) {
        localStorage.removeItem('token')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('user')

        Swal.fire({
          icon: 'info',
          title: 'Sesi Habis',
          text: 'Silakan login ulang',
          confirmColor: '#0B3C85'
        })
      }
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Background Utama */
.login-container {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2f7 0%, #dce4ee 100%);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 1.5rem;
  overflow: hidden;
}

/* Akses Garis Aksen Diagonal */
.brand-stripe-top {
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 350px 200px 0;
  border-color: transparent #ff7a00 transparent transparent;
  opacity: 0.15;
  pointer-events: none;
}

/* Card Login */
.login-card {
  position: relative;
  background: #ffffff;
  padding: 2.5rem 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(11, 60, 133, 0.12);
  width: 100%;
  max-width: 410px;
  border-top: 5px solid #0B3C85;
  animation: fadeIn 0.5s ease-in-out;
}

/* Header Branding */
.brand-header {
  text-align: center;
  margin-bottom: 2.2rem;
}

.brand-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
  filter: drop-shadow(0px 4px 8px rgba(11, 60, 133, 0.15));
}

.company-title {
  font-size: 1.15rem;
  font-weight: 800;
  color: #0B3C85;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.company-subtitle {
  font-size: 0.85rem;
  color: #666;
  margin-top: 0.25rem;
}

/* Form Styles */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 14px;
  display: flex;
  align-items: center;
  pointer-events: none;
  z-index: 2;
}

/* Input Styles */
.input-wrapper input {
  width: 100%;
  padding: 1rem 2.5rem 0.8rem 2.6rem;
  font-size: 0.95rem;
  border-radius: 8px;
  border: 1.5px solid #dcdfe6;
  background-color: #fafafa;
  color: #2c3e50;
  outline: none;
  transition: all 0.25s ease-in-out;
}

/* Floating Label Style Base */
.floating-label {
  position: absolute;
  left: 2.6rem;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  padding: 0 4px;
  color: #888888;
  font-size: 0.9rem;
  pointer-events: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
}

/* Floating Animation Trigger */
.input-wrapper input:focus ~ .floating-label,
.input-wrapper input:not(:placeholder-shown) ~ .floating-label {
  top: 0;
  left: 2.3rem;
  transform: translateY(-50%) scale(0.85);
  background-color: #ffffff;
  color: #ff7a00;
  font-weight: 700;
}

/* Fokus Input Border */
.input-wrapper input:focus {
  border-color: #ff7a00;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(255, 122, 0, 0.12);
}

.input-wrapper input:disabled {
  background-color: #f2f2f2;
  cursor: not-allowed;
}

/* Toggle Password Button */
.toggle-password {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #909399;
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 3;
}

.toggle-password:hover {
  color: #0B3C85;
}

/* Tombol Submit */
.btn-login {
  width: 100%;
  padding: 0.85rem;
  margin-top: 0.5rem;
  background: linear-gradient(135deg, #0B3C85 0%, #1B4D9B 70%, #ff7a00 100%);
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: 0 4px 12px rgba(11, 60, 133, 0.25);
  transition: all 0.3s ease;
}

.btn-login:hover:not(:disabled) {
  background: linear-gradient(135deg, #082d64 0%, #143d7c 60%, #e66e00 100%);
  box-shadow: 0 6px 16px rgba(11, 60, 133, 0.35);
  transform: translateY(-1px);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Loader Spinner */
.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #ffffff;
  animation: spin 0.8s linear infinite;
}

/* Footer Card */
.card-footer {
  margin-top: 2rem;
  text-align: center;
  font-size: 0.75rem;
  color: #888888;
}

/* Keyframe Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>